<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.667 9.778A1.556 1.556 0 007.222 11.333h1.445a1.667 1.667 0 000-3.333H7.333a1.667 1.667 0 010-3.333h1.445c.859 0 1.555.696 1.555 1.555M8 3.667v1m0 6.666v1M14.667 8A6.667 6.667 0 111.333 8a6.667 6.667 0 0113.334 0z"
      stroke="currentColor"
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
